import { gql } from '@apollo/client';

export const UPDATE_COMMENT = gql`
  mutation update_comment($data: UpdateCommentInputType) {
    update_comment(data: $data) {
        hasError
        data
        message
    }
}
`;

export const CREATE_COMMENT = gql`
  mutation create_comment($data: CreateCommentInputType) {
    create_comment(data: $data) {
        hasError
        data
        message
    }
}
`;
